import {
  PaymentMethodType,
  isDigitalWallet,
  isOffSessionUsageSupported,
} from "@circle-react/helpers/paywallCheckoutHelpers";
import type { StripeElementsUpdateOptions } from "./types";
import { stripeElementsSetupFutureUsages } from "./types";

// Apple and Google Pay are valid payment methods but cannot be included as options when updating
// the Elements component because they are included under the "card" capability.
export const resolveStripeElementsPaymentMethodTypes = (
  paymentMethodType: string,
): StripeElementsUpdateOptions["payment_method_types"] =>
  isDigitalWallet(paymentMethodType)
    ? [PaymentMethodType.CARD]
    : [paymentMethodType];

export const resolveStripeElementsSetupFutureUsage = (
  paymentMethodType: string,
) =>
  isOffSessionUsageSupported(paymentMethodType)
    ? stripeElementsSetupFutureUsages.off_session
    : undefined;
